module.exports = __webpack_public_path__ + "a671793ab918f051e8e7110eb944942a.svg";